import { render, staticRenderFns } from "./setVipPermission.vue?vue&type=template&id=08cd671c&scoped=true&"
import script from "./setVipPermission.vue?vue&type=script&lang=js&"
export * from "./setVipPermission.vue?vue&type=script&lang=js&"
import style0 from "./setVipPermission.vue?vue&type=style&index=0&id=08cd671c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cd671c",
  null
  
)

export default component.exports